import { render } from "./TableList.vue?vue&type=template&id=f62988f2&scoped=true&ts=true"
import script from "./TableList.vue?vue&type=script&lang=ts"
export * from "./TableList.vue?vue&type=script&lang=ts"

import "./TableList.vue?vue&type=style&index=0&id=f62988f2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src329832614/src/web-ext-giantstep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f62988f2"]])

export default __exports__